import React, { useRef, useState } from "react"

import classNames from "src/classNames"

export type ExpandableImageProps = {
  images: {
    filename: string
    url?: string
    previewUrl?: string
    thumbUrl?: string
  }[]
}

const ExpandableImageCollection: React.FC<ExpandableImageProps> = ({
  images,
}) => {
  const container = useRef(null)
  const [expanded, setExpanded] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: container.current.offsetTop - 60,
      behavior: "smooth",
    })
  }

  return (
    <div
      ref={container}
      onClick={() => {
        if (expanded) {
          setExpanded(false)
          scrollToTop()
        } else {
          setExpanded(true)
        }
      }}
      className={classNames("flex space-x-4", expanded && "flex-col")}
    >
      {images.map(image => {
        const expandedUrl = image.url || image.previewUrl
        const collapsedUrl = image.thumbUrl || expandedUrl

        return (
          <div key={expandedUrl}>
            <img
              className={classNames(
                expanded ? "cursor-zoom-out" : "cursor-zoom-in",
                expanded ? "max-w-full" : "inline-block max-h-[20rem]"
              )}
              src={expanded ? expandedUrl : collapsedUrl}
              alt={image.filename}
            />
          </div>
        )
      })}
    </div>
  )
}

export default ExpandableImageCollection
